import React from 'react';

import './App.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import ErrorPage from './components/page/error-page.component';
import WrapperPage from './components/layout/wrapper-page.component';
import SignIn from './components/page/sign-in-page/sign-in.component';
import { Route, Switch } from 'react-router-dom';
import routes from './routes';




class App extends React.Component {
  render() {
    return (
      <div >
        <Switch>
          <Route path={routes.signin} component={SignIn}  />
          <Route path={routes.home} component={WrapperPage}  />
          <Route component={ErrorPage} />
        </Switch>
      </div>
    );
  }
}

export default App;
